const getters = {
  isLoading: state => state.isLoading,
  bootstrapData: state => state.data,
  depots: state => state.data && state.data.depots,
  otherDepots: state => state.data && state.data.other_depots,
  vendorDepots: state => state.data && state.data.vendor,
  docks: state => state.data && state.data.docks,
  orderFlow: state => state.data && state.data.order_flow,
  statusList: state => state.data && state.data.status.list,
  statusMappings: state => state.data && state.data.status.mapping,
  features: state => state.data && state.data.features,
  inspection: state => state.data && state.data.inspection,
  inspectionAtDestination: state => state.data && state.data.inspection_at_destination,
  inspectionDocs: state => state.data && state.data.inspection_documents,
  inspectionDocsAtDestination: state => state.data && state.data.inspection_documents_at_destination,
  inspectionBeforeTruckin: state => state.data && state.data.inspection_before_truckin,
  loggedIn: state => state.loggedIn,
  currentClient: state => state.data && state.data.client,
  currentUser: state => state.data && state.data.current_user,
  releaseNotesSettings: state => state.data && state.data.release_notes_settings,
  customFields: state => state.data && state.data.custom_fields,
  configurations: state => state.data && state.data.configurations,
  showTermsDialog: state => state && state.showTermsDialog,
  eximCustomFields: state => state.data && state.data.exim_custom_fields,
  gstStates: state => state.data && state.data.gst_states,
  ssoCheck: state => state.ssoCheck,
  mdmBoostrap: state => state.mdmBoostrap,
  dieselPeg: state => state.data && state.data.dieselPeg,
  cngPeg: state => state.data && state.data.cngPeg,
  fcmToken: state => state.fcmToken,
  environmentVariables: state => state && state.environmentVariables,
  getLogo: state => state && state.logo,
  optimaMultiRunEnabled: state => (state && state.data && state.data.configurations
    && state.data.configurations.optima_multi_run_enabled) || false,
  dashboardOptions: state => (state && state.data && state.data.configurations
    && state.data.configurations.dashboard
    && state.data.configurations.dashboard.enabled_dashboards),
  getPaymentRemainderConfig: state => state && state.data && state.data.configurations &&
    state.data.configurations.payment_remainder,
  getIsPaymentError: state => state.isPaymentError,
  autoLogoutTime: state => (state && state.data && state.data.configurations
    && state.data.configurations.auto_logout_duration),
};

export default getters;
